// extracted by mini-css-extract-plugin
export default {"auto":"Table__auto-U7gGv","fixed":"Table__fixed-c21GJ"};